import script from "./FormImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormImage.vue?vue&type=script&setup=true&lang=ts"

import "./FormImage.vue?vue&type=style&index=0&id=11bcc867&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11bcc867"]])

export default __exports__